export const TransactionStatusTranslate = (status) => {
  switch (status) {
    case "CANCELED":
      return "Cancelada"
    case "IGNORED":
      return "Ignorada"
    case "NEW":
      return "Nova"
    case "READY":
      return "Pronta para ser processada"
    case "WAITING_INTEGRATION":
      return "Esperando integração"
    case "WARNING":
      return "Alguns itens estão com problemas"
    case "IN_PROCESS":
      return "Processando.."
    case "SUCCESS":
      return "Sucesso"
    case "ERROR":
      return "Error"
    case "PAUSED":
      return "Pausada"
    case "FINISHED":
      return "Finalizada"
    case "WAIT_ACTION":
      return "Aguardando ação"
    default:
      return ''
  }
}


// WEBPACK FOOTER //
// ./src/component/Transaction/TransactionStatusTranslate.js